import React from 'react';
import { useDispatch } from 'react-redux';
import { Loading } from 'components/atoms/loading';
import { FilterDrawerWithTrigger } from 'components/molecules/filter-drawer';
import { setDirtyState } from 'data/templates';
import { useStatusUpdatesTemplatesContext } from '../context';
import { useSuTemplateProjectFilterFields } from '../filter-config';
import { FilterWrapper } from './styles';

export const ProjectsFilter = () => {
  const dispatch = useDispatch();
  const [fields, loading] = useSuTemplateProjectFilterFields();

  const { templateId, projectFilter, setProjectFilter } =
    useStatusUpdatesTemplatesContext();

  const onSubmit = (_filter) => {
    dispatch(
      setDirtyState({
        id: templateId,
        _state: true,
      }),
    );
    setProjectFilter(_filter);
  };

  return (
    <FilterWrapper>
      {loading ? (
        <Loading />
      ) : (
        <FilterDrawerWithTrigger
          fields={fields}
          onSubmit={onSubmit}
          filter={projectFilter}
          showMinimumBadges
        />
      )}
    </FilterWrapper>
  );
};
